var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "link (9) 2",
    clipPath: "url(#clip0_10457_3218)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 0C8.95438 0 0 8.95438 0 20C0 31.0456 8.95438 40 20 40C31.0456 40 40 31.0456 40 20C39.9874 8.95961 31.0404 0.0125558 20 0ZM29.0915 15.9591L25.0506 20C23.8498 21.1977 21.9727 21.3874 20.5563 20.4534L20.4534 20.5563C21.3874 21.9727 21.1977 23.8498 20 25.0506L15.9591 29.0915C14.5626 30.4757 12.3099 30.4708 10.9197 29.0803C9.52916 27.6901 9.52428 25.4374 10.9086 24.0409L14.9494 20C16.1503 18.8023 18.0273 18.6126 19.4437 19.5466L19.5466 19.4437C18.6126 18.0273 18.8023 16.1503 20 14.9494L24.0409 10.9086C25.4374 9.52428 27.6901 9.52916 29.0803 10.9197C30.4708 12.3099 30.4757 14.5626 29.0915 15.9591Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M26.5639 11.2915C25.9954 11.2901 25.4499 11.5161 25.0488 11.9193L21.0083 15.9591C20.3707 16.6019 20.2061 17.5757 20.596 18.3922L22.0183 16.9699C22.2984 16.6992 22.7441 16.7031 23.0197 16.9786C23.2952 17.2541 23.299 17.6999 23.0284 17.9799L21.6061 19.4022C22.4226 19.7921 23.3963 19.6275 24.0391 18.99L28.079 14.9494C28.6917 14.3363 28.8749 13.4148 28.5432 12.6144C28.2118 11.8136 27.4306 11.2915 26.5639 11.2915Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.9811 23.03C17.701 23.3007 17.2553 23.2968 16.9798 23.0213C16.7043 22.7458 16.7004 22.3 16.9711 22.02L18.3927 20.5977C17.5772 20.2001 16.5993 20.3657 15.9603 21.0099L11.9205 25.0505C11.0838 25.8875 11.0838 27.2439 11.9205 28.0806C12.7684 28.8897 14.1024 28.8897 14.9506 28.0806L18.9912 24.0408C19.6287 23.398 19.7933 22.4242 19.4034 21.6077L17.9811 23.03Z",
    fill: "#707070"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10457_3218"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.4a07723ba0059881a61e062ffea655f7.svg";
export { ForwardRef as ReactComponent };